import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row align-items-center mb-2" }
const _hoisted_5 = { class: "col-md-4 d-flex align-items-center mb-2 mb-md-0" }
const _hoisted_6 = { class: "ms-2" }
const _hoisted_7 = { class: "col-md-8 d-flex justify-content-end mb-2 mb-md-0" }
const _hoisted_8 = { class: "row align-items-end" }
const _hoisted_9 = { class: "col-md-3 mb-2" }
const _hoisted_10 = { class: "col-md-4 mb-2" }
const _hoisted_11 = { class: "col-md-2 mb-2" }
const _hoisted_12 = { class: "col-md-3 mb-2 d-flex gap-1" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_16 = {
  key: 7,
  class: "dropdown"
}
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 8 }
const _hoisted_29 = {
  class: "modal fade",
  id: "createBLModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-body p-25" }
const _hoisted_33 = { class: "mb-20" }
const _hoisted_34 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_35 = { class: "fw-semibold" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted ms-6 small"
}
const _hoisted_37 = { class: "badge bg-primary ms-10" }
const _hoisted_38 = {
  key: 0,
  class: "text-muted ms-6"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = {
  key: 0,
  class: "text-danger small mt-8"
}
const _hoisted_43 = { class: "modal-footer border-0 pt-0" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-6",
  role: "status"
}
const _hoisted_46 = {
  class: "modal fade",
  id: "detailBonModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_48 = { class: "modal-content p-15 p-md-40" }
const _hoisted_49 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_DetailsNote = _resolveComponent("DetailsNote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "me-2" }, "Voir", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.filters.per_page,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.per_page) = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
                ],
                options: [10, 25, 50, 100],
                clearable: false,
                class: "per-page-selector d-inline-block mx-2",
                style: {"width":"80px"}
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_6, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.auth.can('BL'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCreateBLModal && _ctx.openCreateBLModal(...args)))
                  }, _cache[14] || (_cache[14] = [
                    _createTextVNode(" Nouveau BL ", -1),
                    _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0",
                placeholder: "Chercher",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter())),
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
              }, null, 544), [
                [_vModelText, _ctx.filters.searchTerm]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Magasin", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.client_filter,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.client_filter) = $event)),
                label: "name",
                options: _ctx.clientList
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.status_filter) = $event)),
                class: "form-control",
                style: {"min-width":"140px"}
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("option", { value: "" }, "Status (Tous)", -1),
                _createElementVNode("option", { value: 0 }, "Nouveau", -1),
                _createElementVNode("option", { value: 1 }, "Enregistré", -1)
              ]), 512), [
                [_vModelSelect, _ctx.status_filter]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args)))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-filter" }, null, -1),
                _createTextVNode(" Filtrer ", -1)
              ])),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args)))
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "flaticon-refresh" }, null, -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          loading: _ctx.isLoader
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [20]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_14, _toDisplayString(props.row.note_ref), 1))
              : (props.column.field === 'note_customer_name')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (props.row.client && props.row.client.store)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(props.row.client.store), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(props.row.client.note_customer_name), 1)
                        ], 64))
                  ]))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                    ], 64))
                  : (props.column.field === 'note_total_parcel')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(_toDisplayString(props.row.note_total_parcel) + " Colis ", 1)
                      ], 64))
                    : (props.column.field === 'note_total_crbt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createTextVNode(_toDisplayString(props.row.crbt) + " " + _toDisplayString(_ctx.$devis), 1)
                        ], 64))
                      : (props.column.field === 'crbt')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createTextVNode(_toDisplayString(props.row.crbt) + " " + _toDisplayString(_ctx.$devis), 1)
                          ], 64))
                        : (props.column.field === 'note_saved')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              (props.row.note_saved == 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_saved
              )}`, "text-capitalize"])
                                  }, " Nouveau ", 2))
                                : (props.row.note_saved == 1)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_saved
              )}`, "text-capitalize"])
                                    }, " Enregistré ", 2))
                                  : _createCommentVNode("", true)
                            ], 64))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _cache[28] || (_cache[28] = _createElementVNode("button", {
                                  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                  type: "button",
                                  "data-bs-toggle": "dropdown",
                                  "aria-expanded": "false"
                                }, [
                                  _createElementVNode("i", { class: "flaticon-dots" })
                                ], -1)),
                                _createElementVNode("ul", _hoisted_17, [
                                  (_ctx.auth.can('BL'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                        }, _cache[21] || (_cache[21] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]), 8, _hoisted_19)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.auth.can('BL') && props.row.note_saved == 0)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                        _createVNode(_component_router_link, {
                                          class: "dropdown-item d-flex align-items-center",
                                          to: { name: 'AdminEditDeliveryNote', params: { id: props.row.id, refNote: props.row.note_ref } }
                                        }, {
                                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                                            _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Modifier ", -1)
                                          ])),
                                          _: 2,
                                          __: [22]
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.auth.can('BL') && props.row.note_total_parcel == 0)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.removeBL(props.row.id))
                                        }, _cache[23] || (_cache[23] = [
                                          _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Supprimer ", -1)
                                        ]), 8, _hoisted_22)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                    _ctx.auth.can('BL') &&
                    props.row.note_saved == 0 &&
                    props.row.note_total_parcel != 0
                  )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.saveBL(props.row.id))
                                        }, _cache[24] || (_cache[24] = [
                                          _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Enregistrer ", -1)
                                        ]), 8, _hoisted_24)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("li", null, [
                                    (_ctx.auth.can('BL') && props.row.note_total_parcel != 0)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.getPDF(props.row))
                                        }, _cache[25] || (_cache[25] = [
                                          _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" PDF ", -1)
                                        ]), 8, _hoisted_25))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("li", null, [
                                    (_ctx.auth.can('BL') && props.row.note_total_parcel != 0)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                        }, _cache[26] || (_cache[26] = [
                                          _createElementVNode("i", { class: "flaticon-menu lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Tickets ", -1)
                                        ]), 8, _hoisted_26))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("li", null, [
                                    (_ctx.auth.can('BL') && props.row.note_total_parcel != 0)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.tickets4PDF(props.row))
                                        }, _cache[27] || (_cache[27] = [
                                          _createElementVNode("i", { class: "flaticon-more-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Tickets 4*4 ", -1)
                                        ]), 8, _hoisted_27))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "loading"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title fw-semibold" }, [
              _createElementVNode("i", { class: "flaticon-plus me-8 fs-14" }),
              _createTextVNode(" Nouveau Bon de Livraison ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label fw-semibold mb-8" }, [
                _createTextVNode(" Client / Magasin "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.newBLClient,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newBLClient) = $event)),
                label: "name",
                options: _ctx.blClientList,
                loading: _ctx.blClientLoading,
                filterable: false,
                placeholder: "Rechercher un client...",
                clearable: false,
                onSearch: _ctx.onBLClientSearch,
                onOpen: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadBLClients('')))
              }, {
                option: _withCtx((option) => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(option.name), 1),
                      (option.store)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(option.store), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(option.colis_count) + " colis", 1)
                  ])
                ]),
                "selected-option": _withCtx((option) => [
                  _createTextVNode(_toDisplayString(option.name), 1),
                  (option.store)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, "— " + _toDisplayString(option.store), 1))
                    : _createCommentVNode("", true)
                ]),
                "no-options": _withCtx(({ search }) => [
                  (_ctx.blClientLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Chargement..."))
                    : search
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Aucun client trouvé pour \"" + _toDisplayString(search) + "\"", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_41, "Aucun client avec des colis disponibles"))
                ]),
                _: 1
              }, 8, ["modelValue", "options", "loading", "onSearch"]),
              (_ctx.createBLError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Veuillez sélectionner un client. "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[30] || (_cache[30] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal"
            }, " Annuler ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              disabled: _ctx.createBLLoading,
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.createAdminBL && _ctx.createAdminBL(...args)))
            }, [
              (_ctx.createBLLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.createBLLoading ? "Création..." : "Créer le BL"), 1)
            ], 8, _hoisted_44)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_49, [
            (_ctx.noteBL && Object.keys(_ctx.noteBL).length > 0)
              ? (_openBlock(), _createBlock(_component_DetailsNote, {
                  key: _ctx.noteBL.id,
                  noteBL: _ctx.noteBL,
                  getRecords: _ctx.getRecords,
                  type: true,
                  isOpen: _ctx.isOpen
                }, null, 8, ["noteBL", "getRecords", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}